<template>
<app-base-main :contentStyle="{'height': '100%'}">
  <template #base-content>
  <app-top-tabs ref="costCenterTab" :tabs="tabs" class="stock-tabs" :contentStyle="{'height': '100%'}">
    <template #FBA>
      <costCenterFba ref="FBA" />
    </template>
    <template #SELF>
      <costCenterSelf ref="SELF" />
    </template>
  </app-top-tabs>
  </template>
</app-base-main>
</template>

<script>
  import costCenterFba from './cost-center-fba'
  import costCenterSelf from './cost-center-self'
  import {userGuideMixin} from "../../../../minxins";

  export default {
    name: "cost-center",
    mixins: [userGuideMixin],
    components:{costCenterFba,costCenterSelf},
     watch:{
      userGuideState: {
      handler(val) {
        if(val) {
          this.$refs.costCenterTab.clickTabs('FBA')
        }
      }
      }
    },
    data() {
      return {
        tabs: [
          {id: 'FBA', text: 'listing商品成本'},
          {id: 'SELF', text: '自营仓产品成本'}
        ],
        filterMap: {}
      }
    },
    provide () {
      return {
        provide: this,
      }
    }
  }
</script>

<style scoped lang="scss">
.base-main{
  padding-top: 8px;
}
.stock-tabs{
  /deep/ .tabs{
    width: auto;
    font-size: 13px;
  }
  /deep/ .tabs + .tabs{
    margin-left: 32px;
  }
}
</style>
